<ng-template
    #quickNavItem
    let-item="item"
    let-icon="icon">
    <div class="flex items-center gap-2 text-primary dark:text-white dark:hover:text-primary-300 hover:text-primary-300">
        @if (item.icon) {
            <big-icon
                [icon]="icon"
                [size]="'w-5'"
                class="fill-primary dark:fill-white" />
        }
        <span>{{ item.title }}</span>
    </div>
</ng-template>

@let currentHeaderMenus = headerMenus();
@let currentSubNavItem = subnavItem();

@if (currentSubNavItem) {
    <div
        class="px-6 py-9 md:py-6 flex flex-col"
        id="nav-subnav">
        <big-ui-button
            [buttonStyle]="'none w-full'"
            (click)="closeSubnav()">
            <div class="flex items-center w-full gap-2 p-4 font-ci text-primary dark:text-white rounded-lg hover:bg-white">
                <big-icon
                    [icon]="iconAngleLeft"
                    [size]="'w-4'"
                    class="fill-current" />
                <span>{{ backTranslation() }}</span>
            </div>
        </big-ui-button>
        <h6 class="mt-6 px-2 mb-0">{{ currentSubNavItem?.title }}</h6>

        @let children = currentSubNavItem?.children;

        @if (children) {
            <ul class="space-y-2 -mb-6 pt-4 pb-6 overflow-auto -mx-6 px-6">
                @for (sub of children; track $index) {
                    <li>
                        <big-ui-link
                            (click)="onNavItemSelected()"
                            linkClass="none hover:text-primary rounded-lg hover:bg-white md:hover:bg-primary-50 font-sans leading-[1.6]"
                            [href]="sub.uri">
                            <div class="py-1 px-2">
                                {{ sub.title }}
                            </div>
                        </big-ui-link>
                    </li>
                }
            </ul>
        }
        <div class="hidden md:block absolute bottom-0 left-0 right-0 h-6 bg-linear-to-b from-white/0 to-white dark:from-primary/0 dark:to-primary"></div>
    </div>
} @else if (currentHeaderMenus) {
    @let items = isLoggedIn() && currentHeaderMenus?.mainLoggedIn
        ? currentHeaderMenus?.mainLoggedIn?.items
        : currentHeaderMenus?.main?.items;

    <div class="px-6 py-9 md:py-6 font-ci text-primary dark:text-white">
        <ul class="space-y-2 md:mb-0">
            @for (item of items ?? []; track $index) {
                <li>
                    @if (!item.children.length) {
                        <big-ui-link
                            [href]="item.uri"
                            class="flex items-center justify-between w-full p-4 rounded-lg hover:bg-white md:hover:bg-primary-50"
                            linkClass="no-underline">
                            <span>{{ item.title }}</span>
                        </big-ui-link>
                    } @else {
                        <button
                            (click)="openSubnav(item)"
                            class="flex items-center justify-between w-full p-4 rounded-lg hover:bg-white md:hover:bg-primary-50">
                            {{ item.title }}
                            <big-icon
                                [icon]="iconAngleRight"
                                [size]="'w-4'"
                                class="fill-current" />
                        </button>
                    }
                </li>
            }
        </ul>

        <big-nav-quicknav
            class="block p-4 md:hidden"
            wrapperClass="!justify-between flex-wrap"
            [itemTemplate]="quickNavItem"
            [menu]="currentHeaderMenus?.tools"
            (itemClicked)="sidenavService.closeSidenav()" />
    </div>
}
